import {
  GET_ALL_ROLES_DETAILS,
  GET_HELLO_ADMIN_DETAILS,
  GET_USER_ROLE_DETAILS,
  GET_USER_TYPE_DETAILS,
  GET_CHAIN_NAME,
  GET_PROVIDERS_BY_CHAIN_ID,
} from "../../Utils/types";

const initialState = {
  getUserRoleDetails: null,
  getHelloAdminDetails: null,
  getUserTypeDetails: null,
  getAllRoles: null,
  getChainName: null,
  getProvidersByChainId: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_HELLO_ADMIN_DETAILS:
      return {
        ...state,
        getHelloAdminDetails: action.payload,
      };
    case GET_ALL_ROLES_DETAILS:
      return {
        ...state,
        getAllRoles: action.payload,
      };
    case GET_USER_ROLE_DETAILS:
      return {
        ...state,
        getUserRoleDetails: action.payload,
      };
    case GET_USER_TYPE_DETAILS:
      return {
        ...state,
        getUserTypeDetails: action.payload,
      };
    case GET_CHAIN_NAME:
      return {
        ...state,
        getChainName: action.payload,
      };
    case GET_PROVIDERS_BY_CHAIN_ID:
      return {
        ...state,
        getProvidersByChainId: action.payload,
      };
    default:
      return state;
  }
};
